import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-poppins\",\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Tajawal\",\"arguments\":[{\"subsets\":[\"latin\",\"arabic\"],\"variable\":\"--font-tajawal\",\"weight\":[\"200\",\"300\",\"400\",\"500\",\"700\",\"800\",\"900\"]}],\"variableName\":\"tajawal\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/(pages)/home/ThemeProvider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/toast.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/TanstackProvider.jsx");
